import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3af866ca = () => interopDefault(import('../pages/apps/index.vue' /* webpackChunkName: "pages/apps/index" */))
const _4405d451 = () => interopDefault(import('../pages/auth/index.vue' /* webpackChunkName: "pages/auth/index" */))
const _427edbde = () => interopDefault(import('../pages/changePassword.vue' /* webpackChunkName: "pages/changePassword" */))
const _c0ca05e0 = () => interopDefault(import('../pages/loyalty.vue' /* webpackChunkName: "pages/loyalty" */))
const _5f5058f3 = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _c47ab450 = () => interopDefault(import('../pages/stores.vue' /* webpackChunkName: "pages/stores" */))
const _a7cfe31a = () => interopDefault(import('../pages/account/delete.vue' /* webpackChunkName: "pages/account/delete" */))
const _1ab648cd = () => interopDefault(import('../pages/auth/verifyRegister.vue' /* webpackChunkName: "pages/auth/verifyRegister" */))
const _1db85e32 = () => interopDefault(import('../pages/order/cart.vue' /* webpackChunkName: "pages/order/cart" */))
const _48b3f08d = () => interopDefault(import('../pages/order/checkout.vue' /* webpackChunkName: "pages/order/checkout" */))
const _347ff8a7 = () => interopDefault(import('../pages/order/logistic.vue' /* webpackChunkName: "pages/order/logistic" */))
const _661c87e2 = () => interopDefault(import('../pages/order/payment.vue' /* webpackChunkName: "pages/order/payment" */))
const _601a40bc = () => interopDefault(import('../pages/order/thankyou.vue' /* webpackChunkName: "pages/order/thankyou" */))
const _dbc70f7e = () => interopDefault(import('../pages/order/tracker.vue' /* webpackChunkName: "pages/order/tracker" */))
const _8b603fc8 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _54c6bf96 = () => interopDefault(import('../pages/menu/product/_.vue' /* webpackChunkName: "pages/menu/product/_" */))
const _32355214 = () => interopDefault(import('../pages/menu/deal/_.vue' /* webpackChunkName: "pages/menu/deal/_" */))
const _0d997b55 = () => interopDefault(import('../pages/menu/_.vue' /* webpackChunkName: "pages/menu/_" */))
const _13265938 = () => interopDefault(import('../pages/info/_.vue' /* webpackChunkName: "pages/info/_" */))
const _45aa5bae = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/apps",
    component: _3af866ca,
    name: "apps"
  }, {
    path: "/auth",
    component: _4405d451,
    name: "auth"
  }, {
    path: "/changePassword",
    component: _427edbde,
    name: "changePassword"
  }, {
    path: "/loyalty",
    component: _c0ca05e0,
    name: "loyalty"
  }, {
    path: "/profile",
    component: _5f5058f3,
    name: "profile"
  }, {
    path: "/stores",
    component: _c47ab450,
    name: "stores"
  }, {
    path: "/account/delete",
    component: _a7cfe31a,
    name: "account-delete"
  }, {
    path: "/auth/verifyRegister",
    component: _1ab648cd,
    name: "auth-verifyRegister"
  }, {
    path: "/order/cart",
    component: _1db85e32,
    name: "order-cart"
  }, {
    path: "/order/checkout",
    component: _48b3f08d,
    name: "order-checkout"
  }, {
    path: "/order/logistic",
    component: _347ff8a7,
    name: "order-logistic"
  }, {
    path: "/order/payment",
    component: _661c87e2,
    name: "order-payment"
  }, {
    path: "/order/thankyou",
    component: _601a40bc,
    name: "order-thankyou"
  }, {
    path: "/order/tracker",
    component: _dbc70f7e,
    name: "order-tracker"
  }, {
    path: "/",
    component: _8b603fc8,
    name: "index"
  }, {
    path: "/menu/product/*",
    component: _54c6bf96,
    name: "menu-product-all"
  }, {
    path: "/menu/deal/*",
    component: _32355214,
    name: "menu-deal-all"
  }, {
    path: "/menu/*",
    component: _0d997b55,
    name: "menu-all"
  }, {
    path: "/info/*",
    component: _13265938,
    name: "info-all"
  }, {
    path: "/*",
    component: _45aa5bae,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
